angular.module('acme.view.application.settings.terminals.posCloudConfigurationModal.controllers', [])
  .controller('SettingsTerminalsPosCloudConfigurationModalController', SettingsTerminalsPosCloudConfigurationModalController);

/**
 * Controller responsible for showing the POS Cloud Configuration Modal
 * @class SettingsTerminalsPosCloudConfigurationModalController
 * @constructor
 * @param $uibModalInstance
 * @param {Object} response - this is either the configuration object or an error with the relevant meta data
 * @return {SettingsTerminalsPosCloudConfigurationModalController} - Class instance
 */
function SettingsTerminalsPosCloudConfigurationModalController($uibModalInstance, response) {

  Object.assign(this, {
    configuration: '',
    error: '',
    close: close
  });

  function close() {
    $uibModalInstance.dismiss();
  }

  // We assume if the response has a status then it's likely not succeeded, so:
  if (response.status) {
    if (response.status === 404) {
      this.error = 'No cloud configuration found for this terminal.';
    } else {
      this.error = 'Unable to load the cloud configuration for this terminal.';
    }
  } else {
    this.configuration = response;
  }
}

SettingsTerminalsPosCloudConfigurationModalController.$inject = ['$uibModalInstance', 'response'];
